import React, { useCallback } from "react";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./css/Publish.module.css";
import { Button } from "antd";
import func from "@uikit/func";
import { logEvent } from "@uikit/service/amplitude";
import useFeatureTags from "../../custom-hooks/useFeatureTags";

function Publish(props) {
  const imagicaStudioTutorial = useSelector(state => state.fot.imagicaStudioTutorial);
  const enableExperimentalFeature = useSelector(state => state.fot.enableExperimentalFeature);
  const feature_tags = useFeatureTags();
  const [selectedArr, setSelectedArr] = useState([]);
  const [publishList, setPublishList] = useState([
    {
      title: "Web Application",
      key: "saas",
      describe: "Export your expertise as a web app",
      className: "web-app",
      background: "webAppFrame",
      disabled: false,
      visible: true,
    },
    {
      title: "Saas Website",
      key: "saasV2",
      describe: "Turn your idea into a business.",
      className: "saas-website",
      background: "saasWebsiteFrame",
      disabled: false,
      visible: feature_tags.enable_saas_web ? true : false,
    },
    {
      title: "Thinking App",
      key: "thinkingApp",
      describe: "App Inside Natural.",
      className: "thinking-app",
      background: "thinkingAppFrame",
      disabled: true,
      visible: true,
    },
  ]);

  const clickFormat = item => {
    const { key, disabled } = item;
    if (imagicaStudioTutorial.showGuide) {
      setTimeout(() => {
        clickConfirmBtn(props.guidePublishData.selectedArr);
      }, 500);
      return;
    }
    if (disabled) return;
    // let arr = selectedArr || []
    // if(selectedArr.includes(key)) {
    //   const index = arr.findIndex(x => x === key)
    //   arr.splice(index, 1)
    // } else {
    //   arr.push(key)
    // }
    // 只能单选
    setSelectedArr([key]);
    const eventProperties = {
      format: item.title,
    };
    logEvent("click_publish_format", eventProperties);
  };

  const clickConfirmBtn = selectedArrParam => {
    const arr = selectedArrParam.map(x => {
      const obj = publishList.find(y => y.key === x);
      return {
        label: obj?.title,
        value: obj?.key,
        isStaticApp: false,
      };
    });
    props.setIsPublish(false);
    props.setShowPreviewPanel(true);
    props.setCheckedUIList(arr);
    props.setSelectedUI(arr[0].value);
    if (imagicaStudioTutorial.showGuide) {
      props.clickStep(10, () => {}, true);
      props.setCurrentGuideTitlePage("end");
    }
    if (arr.some(x => x.value === "saasV2")) {
      props.autoLoadInputField("saasV2");
    }
    if (arr.some(x => x.value === "saas")) {
      props.autoLoadInputField("saas");
    }
    props.autoAddOutPutNode();
    logEvent("click_publish_confirm");
  };

  useEffect(() => {
    let arr = [];
    if (!func.isEmpty(props.checkedUIList)) {
      arr = props.checkedUIList.map(x => x.value);
    }
    if (!enableExperimentalFeature) {
      arr = arr.filter(x => x !== "thinkingApp");
    }
    setSelectedArr(arr);
  }, []);

  useEffect(() => {
    if (!imagicaStudioTutorial.showGuide) return;

    setSelectedArr(props.guidePublishData.selectedArr);
    setPublishList(prevList => {
      return prevList.map(x => {
        if (!props.guidePublishData.selectedArr.includes(x.key)) {
          return {
            ...x,
            disabled: true,
          };
        }
        return x;
      });
    });
  }, [props.guidePublishData]);

  useEffect(() => {
    // 禁用后如果之前选中则取消选中状态
    if (!enableExperimentalFeature && selectedArr.includes("thinkingApp")) {
      if (selectedArr.length === 1) {
        setSelectedArr([]);
        props.setShowPreviewPanel(false);
        props.setIsPublish(false);
        props.setCheckedUIList([]);
        props.setSelectedUI("");
        return;
      }
      const newSelectArr = selectedArr.filter(x => x !== "thinkingApp");
      setSelectedArr(newSelectArr);
      clickConfirmBtn(newSelectArr);
    }
    setPublishList(prevList => {
      return prevList.map(x => {
        if (x.key === "thinkingApp") {
          return {
            ...x,
            disabled: !enableExperimentalFeature,
          };
        }
        return x;
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableExperimentalFeature]);

  return (
    <div className={style["publish-box"]}>
      <div
        className={style["cross"]}
        onClick={() => {
          logEvent("close_publish_1");
          props.setIsPublish(false);
          props.cancelCreatePreview();
        }}
      ></div>
      <div className={style["publish-title"]}>Share</div>
      <div className={style["publish-describe"]}>Turn your thoughts into reality with just a click.</div>
      <div className={style["publish-format"]}>Choose a format</div>

      <div className={style["publish-center"]}>
        {publishList.map(x => {
          return (
            <div
              key={x.key}
              style={{ display: x.visible ? "block" : "none" }}
              className={`${style["format-piece"]} ${x.className} ${
                selectedArr.includes(x.key) ? style["selected"] : ""
              } ${x.disabled ? style["disable-template"] : ""}`}
              onClick={() => clickFormat(x)}
            >
              <div className={style["format-text-box"]}>
                <div className={style["format-title"]}>{x.title}</div>
                <div className={style["format-describe"]}>{x.describe}</div>
              </div>
              <div className={x.background}></div>
            </div>
          );
        })}
      </div>
      <Button
        type="primary"
        disabled={func.isEmpty(selectedArr)}
        className={style["publish-confirm"]}
        size="small"
        onClick={() => clickConfirmBtn(selectedArr)}
      >
        Confirm
      </Button>
    </div>
  );
}

export default Publish;
